import { getGamesAPI } from "../api/apiConfig";

import overview from "../assets/page_assets/sidebar_icon/overview.svg";
import overview_active from "../assets/page_assets/sidebar_icon/overview_active.svg";
import board_active from "../assets/page_assets/sidebar_icon/board_active.svg";
import card_active from "../assets/page_assets/sidebar_icon/card_active.svg";
import live_active from "../assets/page_assets/sidebar_icon/live_active.svg";
import casino_active from "../assets/page_assets/sidebar_icon/casino_active.svg";
import table_active from "../assets/page_assets/sidebar_icon/table_active.svg";
import live from "../assets/page_assets/sidebar_icon/live.svg";
import casino from "../assets/page_assets/sidebar_icon/casino.svg";
import board from "../assets/page_assets/sidebar_icon/board.svg";
import card from "../assets/page_assets/sidebar_icon/card.svg";
import table from "../assets/page_assets/sidebar_icon/table.svg";

export const Getgamedetails = async (
  gamesdetails,
  setgamesdetails,
  gamescatdetails,
  setgamescatdetails,
  setgamemenu,
  setOverviewGames
) => {
  try {
    const check_localdata = gamesdetails;
    let gamedata;
    let game_category;

    if (
      check_localdata === null ||
      check_localdata === undefined ||
      check_localdata === "undefined" ||
      check_localdata?.length === 0
    ) {

      const response = await getGamesAPI();

      gamedata = response.data;

      // normalize field name for both environments
      gamedata.data = gamedata.data.map(game => ({
        ...game,
        buyin_player_detail: game.gamedata_detail || game.buyin_player_detail
      }));

      setgamesdetails(gamedata.data);
      setgamescatdetails(gamedata.game_category);
      game_category = gamedata.game_category;
      localStorage.setItem("gamesdetails", JSON.stringify(gamedata.data));
      localStorage.setItem("category", JSON.stringify(gamedata.game_category));

      let OverviewGames__ = {};
      const all = [];
      const games = gamedata.data;
      const parsedCategory = game_category;

      const getGameTypeLabel = (gameTypeId, categoryList) => {
        const category = categoryList.find(
          (cat) => String(cat.id) === String(gameTypeId)
        );
        return category?.gametype || "unknown";
      };

      games.forEach((game) => {
        const type = String(game.game_type);
        const typelabel = getGameTypeLabel(type, parsedCategory);
        const name = game.gamename;
        if (!name) return;

        if (!OverviewGames__[typelabel]) {
          OverviewGames__[typelabel] = [];
        }
        OverviewGames__[typelabel].push({
          id: game.id,
          gamename: name
        });
      });

      const categoryIdMap = parsedCategory.reduce((acc, cat) => {
        const name = cat.gametype;
        acc[name] = Number(cat.id);
        return acc;
      }, {});

      OverviewGames__ = Object.fromEntries(
        Object.entries(OverviewGames__).sort(([catA], [catB]) => {
          const idA = categoryIdMap[catA] || Number.MAX_SAFE_INTEGER;
          const idB = categoryIdMap[catB] || Number.MAX_SAFE_INTEGER;
          return idA - idB;
        })
      );

      Object.keys(OverviewGames__).forEach((category) => {
        OverviewGames__[category].sort((a, b) =>
          a.gamename.localeCompare(b.gamename)
        );
      });

      localStorage.setItem("OverAllGames", JSON.stringify(OverviewGames__));
      setOverviewGames(OverviewGames__);

    } else {
      game_category = gamescatdetails;
      gamedata = gamesdetails;
    }

    const baseMenu = [{
      label: "Home",
      inactiveImg: overview,
      activeImg: overview_active,
      url: "/"
    }];

    const imageMap = {
      Live:     { inactiveImg: live,     activeImg: live_active     },
      Casino:   { inactiveImg: casino,   activeImg: casino_active   },
      Card:     { inactiveImg: card,     activeImg: card_active     },
      Table:    { inactiveImg: table,    activeImg: table_active    },
      Board:    { inactiveImg: board,    activeImg: board_active    },
      Overview: { inactiveImg: overview, activeImg: overview_active },
    };

    const dynamicMenu = game_category.map((item) => {
      const key = item.gametype.split(" ")[0];
      const imageConfig = imageMap[key] || {};
      return {
        label: item.gametype,
        inactiveImg: imageConfig.inactiveImg,
        activeImg: imageConfig.activeImg,
        url: "games?category=" + key.toLowerCase()
      };
    });

    setgamemenu(baseMenu.concat(dynamicMenu));
    return gamedata.data || gamedata;

  } catch (error) {
    console.error("Get game Error:", error);
    alert("Something went wrong. Please try again.");
  }
};